import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shareData"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import useSearchParameter from 'hooks/useSearchParameter';
import ShareContentModal from 'screens/ShareModal';
import FormField from 'components/FormField';
import InlineList from 'components/InlineList';
import Button from 'components/Button';
import { TEAM_ICONS } from 'utils/icons';
import { hasPrivilege } from 'utils/privileges';
function ShareNowField(_ref) {
  var shareData = _ref.shareData,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var _useSearchParameter = useSearchParameter('type'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 2),
    type = _useSearchParameter2[0],
    setType = _useSearchParameter2[1];
  var isContentAdmin = hasPrivilege('asset_read') || hasPrivilege('playlist_read');
  if (!isContentAdmin) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('form_share_with'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "s"
  }, shareData.overallContentAudienceType !== 'admin' && /*#__PURE__*/React.createElement(Button, {
    icon: TEAM_ICONS.TEAM,
    onClick: function onClick() {
      return setType('teams');
    }
  }, t('state_teams_or_everyone')), /*#__PURE__*/React.createElement(Button, {
    icon: "user",
    onClick: function onClick() {
      return setType('users');
    }
  }, t('state_individual_users')))), !!type && /*#__PURE__*/React.createElement(ShareContentModal, {
    data: shareData,
    onClose: function onClose() {
      return setType(undefined);
    },
    initialShareType: type
  }));
}
export default ShareNowField;